import { createSlice } from '@reduxjs/toolkit';
import logger from "../../lib/appfuse-react/core/logger";
import {json} from "../../lib/appfuse-react/core/json";
import lang from "../../lib/appfuse-react/core/lang";
import Sort from "../../lib/appfuse-react/core/Sort";


const LOGGER = logger.getLogger('cropApplicationReducer');

const name = 'cropApplicationDraft';

const initialState = {
    data: [],
    selection: null,
    pageNumber: 0,
    pageSize: 10,
    fieldPageNumber: 0,
    fieldPageSize: 5,
    criteria: {},
    sort: null,
    fieldSort: null,
    drafts: {},
    field: {},
    fieldChange: {},
    farmMap: {},
    nodeId: null
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = json.toJSON(action.payload);
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setCriteria(state, action) {
            state.criteria = json.toJSON(action.payload);
        },
        setSort(state, action) {
            state.sort = json.toJSON(action.payload);
        },
        setDrafts(state, action) {
            state.drafts = json.toJSON(action.payload);
        },
        setNodeId(state, action){
            state.nodeId = action.payload;
        },
        setCertificationField(state, action){
            state.field = json.toJSON(action.payload);
        },
        setFieldChange(state, action){
            state.fieldChange = json.toJSON(action.payload);
        },
        setFieldPageNumber(state, action) {
            state.fieldPageNumber = action.payload;
        },
        setFieldPageSize(state, action) {
            state.fieldPageSize = action.payload;
        },
        setFarmMap(state, action) {
            state.farmMap = json.toJSON(action.payload);
        },
        setFieldSort(state, action){
            state.fieldSort = json.toJSON(action.payload);
        }
    }
});

export const { setSelection, setPageNumber, setPageSize, addDraft, setData, setNodeId, setDrafts, setFieldPageNumber, setFieldPageSize, setCertificationField, setFieldChange, setFarmMap, setFieldSort } = slice.actions;
export const { reducer } = slice;

export const selectData = state => json.fromJSON(state[name].data);
export const selectCriteria = state => state[name].criteria;
export const selectSort = state => json.fromJSON(state[name].sort, Sort);
export const selectSelection = state => json.fromJSON(state[name].selection);
export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectCertificationField = state => json.fromJSON(state[name].field);
export const selectFieldChange = state => json.fromJSON(state[name].fieldChange);
export const selectFieldPageNumber = state => state[name].fieldPageNumber;
export const selectFieldPageSize = state => state[name].fieldPageSize;
export const selectFieldSort = state => json.fromJSON(state[name].fieldSort, Sort);
export const selectFarmMap = state => json.fromJSON(state[name].farmMap);
export const selectNodeId = state => state[name].nodeId;
export const selectDrafts = state => json.fromJSON(state[name].drafts);
export const selectApplicationDraft = (key) => (state) => selectDrafts(state)[key];

export const setApplicationDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    drafts[key] = draft;
    dispatch(setDrafts(drafts));
}

export const removeDraft = key => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    delete drafts[key];
    dispatch(setDrafts(drafts));
}

const cropApplicationDraftReducer = reducer;
export default cropApplicationDraftReducer;

